function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#9DA9B0",
  fillRule: "nonzero",
  d: "M7.92 11.13c-1.94 0-3.5-1.37-3.5-3.46 0-2.1 1.56-3.45 3.5-3.45 1.3 0 2.15.62 2.68 1.38l-.95.55c-.36-.5-.99-.89-1.73-.89-1.32 0-2.3 1-2.3 2.41 0 1.39.98 2.41 2.3 2.41.68 0 1.28-.31 1.58-.6V8.45h-2V7.42h3.16v2.49c-.65.73-1.59 1.22-2.74 1.22zm5.016-.13h-1.17V4.33h1.17V11zm2.475 0h-1.17V4.33h4.57v1.03h-3.4v1.72h3.33v1.03h-3.33V11zM3 0h17a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 1.3A1.7 1.7 0 0 0 1.3 3v10A1.7 1.7 0 0 0 3 14.7h17a1.7 1.7 0 0 0 1.7-1.7V3A1.7 1.7 0 0 0 20 1.3H3z"
});

function SvgGif(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "assets/media/gif.38273b0a.svg";
export { ForwardRef as ReactComponent };